import { Alert, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetWorkspaceSubscription } from 'hooks/workspacePlan/useGetWorkspaceSubscription';
import { useGetWorkspacePlans } from 'hooks/workspacePlan/useGetWorkspacePlans';
import { CurrentSubscriptionSection } from './subscriptionPlan/CurrentSubscriptionSection';
import { WorkspacePlansTable } from './subscriptionPlan/WorkspacePlansTable';
import { LoaderContainer, SectionAlert } from './subscriptionPlan/SubscriptionPlan.styles';

export const SubscriptionPlanTab = () => {
    const { t } = useTranslation();
    const { subscription, subscriptionLoading, subscriptionRefetching, subscriptionError } = useGetWorkspaceSubscription();
    const { plans, plansLoading, plansRefetching, plansError } = useGetWorkspacePlans();

    if (subscriptionLoading || plansLoading) {
        return (
            <LoaderContainer>
                <CircularProgress />
            </LoaderContainer>
        );
    }

    return (
        <Box>
            {subscriptionError || !subscription ? (
                <SectionAlert severity="error">{t('subscriptionPlan.subscriptionLoadError')}</SectionAlert>
            ) : (
                <CurrentSubscriptionSection
                    subscription={subscription}
                    plans={plans}
                    refetching={subscriptionRefetching}
                />
            )}

            {plansError ? (
                <Alert severity="error">{t('subscriptionPlan.plansLoadError')}</Alert>
            ) : (
                <WorkspacePlansTable
                    plans={plans}
                    currentPlanId={subscription?.planId}
                    refetching={plansRefetching}
                />
            )}
        </Box>
    );
};
